import { useEffect, useState } from "react";
import { responseMsg } from "../common/ResponseMsg";
import DataChartNew from "./DataChartNew";
import moment from 'moment';
import { gridBadgeRender, getStatusGroupColor } from "../common/Common";
import Flex from "../../shared/components/Flex";
import Card from "../../shared/components/Card";
import Padding from "../../shared/components/Padding";
import Text from "../../shared/components/Text";
import Spacer from "../../shared/components/Spacer";
import AgGridTable from "../common/AgGridTable";
import useDevice from "../../shared/hooks/useDevice";

function DetailComponentNew(props) {
    const [ selectedSensor, setSelectedSensor] = useState(props.data);
    const [ measurement, setMeasurement ] = useState();
    const [ pagination, setPagination ] = useState();
    const device = useDevice();
    const isMobile = device !== 'desktop';

    const apiGetSensorsLog = (page) => {
        const pagingSize = 20;

        if (props.searchProps.interval) {
            const tmp = {...props.searchProps, startDate:moment(props.searchProps.startDate).format("YYYY.MM.DD HH:mm:ss")}

            fetch(`/api/system/sensors/new/${selectedSensor?.imei}/${tmp.startDate}/${tmp.endDate}?page=${page-1}&size=${pagingSize}`, {
                method: "GET"
            })
            .then((res) => res.json())
            .then((json) => {
                if(json.code === responseMsg.SUCCESS.code) {
                    setMeasurement(json.data.map(ele => {
                        return {
                            ...ele,
                            create_dtm_day:moment(ele.create_dtm).format("YYYY-MM-DD"),
                            create_dtm_time:moment(ele.create_dtm).format("HH:mm"),
                        };
                    }));

                    setPagination(json.pagination);
                }
            })
        }
    }

    useEffect(() => {
        apiGetSensorsLog(1);
        props.setDetailGrid(gridConfig.columnDefs);

    }, [selectedSensor, props.searchProps,])

    // gridTable config
    const gridConfig = {
        columnDefs: [
            { headerName: '번호', flex:0.1, minWidth:80, valueGetter: `node.rowIndex + ${pagination && (pagination.currentPageNo - 1) * pagination.recordsPerPage + 1}` },
            { headerName: '날짜', flex:0.1,minWidth:150, field: 'baseDt'},
            { headerName: '시간', flex:0.1,minWidth:100, field: 'baseTm'},
            { headerName: '온도(°C)', flex:0.1,minWidth:100, field: 'temp', cellRenderer: (props) => gridBadgeRender(props.value,"white","red")},
            { headerName: '습도(%)', flex:0.1,minWidth:100, field: 'humidity', cellRenderer: (props) => gridBadgeRender(props.value,"white","blue")},
            { headerName: '풍속(m/s)', flex:0.1,minWidth:100, field: 'windSpeed', cellRenderer: (props) => gridBadgeRender(props.value,"white","green")},
            { headerName: '만조시간', flex:0.1,minWidth:180, field: 'tideHighTime'},
            { headerName: '간조시간', flex:0.1,minWidth:180, field: 'tideLowTime'},
            { headerName: '미세먼지(㎍/㎥)', flex:0.1,minWidth:140, field: 'pm10Value'},
            { headerName: '예특보', flex:0.1,minWidth:100, field: 'weatherStatusName'}
        ],
        pagination: true,
        suppressRowHoverHighlight: true,
        rowData: measurement,
    }


    return (
        <Flex noWrap={true} fullWidth flexDirection="column" gap={10} style={{flex: 1}}>
            { props.customBtnWrap && ( props.customBtnWrap ) }                   
            {
                props.showChart && <DataChartNew 
                    searchProps={props.searchProps}
                    selectedSensor={selectedSensor}
                />
            }
            {
                !props.showChart && 
                <Card fullWidth style={{ flex: 1, display: 'flex' }}>
                    <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column", height: isMobile ? "400px" : "auto" }}>
                        <Text weight={"bold"}>제품데이터 목록</Text>
                        <Spacer direction='vertical' size={15} />
                        <AgGridTable
                            suppressRowHoverHighlight={true}
                            columnDefs={gridConfig.columnDefs}
                            rowData={gridConfig.rowData}
                            defaultColDef={{
                                sortable: true,
                                resizable: true,
                            }}
                            tooltipShowDelay={0}
                            tooltipHideDelay={2000}
                            onPageChange={apiGetSensorsLog}
                            pagination={pagination}
                        />
                    </Padding>
                </Card>
            }
        </Flex>
    )
}

export default DetailComponentNew;